import script from "./WhiteboardMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteboardMenu.vue?vue&type=script&setup=true&lang=js"

import "./WhiteboardMenu.vue?vue&type=style&index=0&id=6a675918&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a675918"]])

export default __exports__